export default [
  {
    path: '/settings',
    component: () => import('@/views/settings/SettingsPage.vue'),
    meta: { 
      title:'Settings',
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'settings_dashboard',
    },
  }
]